import Backbone from 'backbone';
import Modal from 'app/backbone/components/modals/Modal.view';
import * as Account from 'app/backbone/models/account/Account';
import * as Event from 'app/backbone/models/event/Event';
import * as Day from 'app/backbone/models/event/Day';
import * as Stage from 'app/backbone/models/event/Stage';
import * as RiderType from 'app/backbone/models/account/artists/RiderType';
import Form from 'app/backbone/components/forms/Form.mixin';
import template from './DownloadRiderModal.hbs';

const DownloadRiderModal = Modal.extend({

    template,

    mixins: [
        Form
    ],

    ui: {
        riderDownloadButton: '.download'
    },

    events: {
        'click riderDownloadButton': 'download'
    },

    options: [
        { 'width': 400 }
    ],

    initialize(options) {
        this._super(options);

        const account = new Account.Model().fetchFromDOM();
        const event = new Event.Model(null, { account }).fetchFromDOM();
        this.event = event;
        this.days = new Day.Collection(null, { event }).fetchFromDOM();
        this.stages = new Stage.Collection(null, { event }).fetchFromDOM();
        this.stagesRenamed = new Stage.Collection()
            .setIncludes(['day'])
            .fetchFromDOM();
        this.stagesRenamed.forEach((stage) => {
            stage.set('name', `${stage.getRelation('day').get('name')} - ${stage.get('name')}`);
        });
        this.riderTypes = new RiderType.Collection().fetchFromDOM();

        this.days.add({ id: 0, name: 'All days' }, { at: 0 });
        this.stages.add({ id: 0, name: 'All stages' }, { at: 0 });
        this.stagesRenamed.add({ id: 0, name: 'All stages' }, { at: 0 });
    },

    render() {
        this.$el.html(this.template());
        this.resolveHandles();
        this.delegateEvents();
    },



    initForm() {
        const { days, stagesRenamed, riderTypes } = this;
        this.inputs = new Backbone.ChildViewContainer();

        this.daysSelectize = this.initSingleSelectize('days', { collection: days });
        this.stagesSelectize = this.initSingleSelectize('stages', { collection: stagesRenamed });
        this.typesSelectize = this.initSingleSelectize('types', { collection: riderTypes });
        this.inputs.add(this.daysSelectize, 'days');
        this.inputs.add(this.stagesSelectize, 'stages');
        this.inputs.add(this.typesSelectize, 'types');
        this.listenTo(this.daysSelectize, 'selected', this.onDaySelected);
    },

    renderForm() {
        this.inputs.call('render');
    },

    open() {
        this.render();
        this.initForm();
        this.delegateEvents();
        this.renderForm();
        this.show();
    },

    download() {
        const event = this.event;
        const dayId = this.daysSelectize.getSelectedValue();
        const stageId = this.stagesSelectize.getSelectedValue();
        const typeId = this.typesSelectize.getSelectedValue();
        navigate(
            `/events/${event.id}/artists/reports/riders?day=${dayId}&stage=${stageId}&type=${typeId}`,
            { pageReload: true }
        );
    },

    onDaySelected(day) {
        const { stages, stagesRenamed } = this;
        if (day.get('id') !== 0) this.stagesSelectize.setCollection(stages.filterByDay(day));
        else this.stagesSelectize.setCollection(stagesRenamed);
    }
});

export default DownloadRiderModal;
